/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FineMetricItem
 */
export interface FineMetricItem {
    /**
     * 
     * @type {string}
     * @memberof FineMetricItem
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof FineMetricItem
     */
    value: number;
    /**
     * 
     * @type {number}
     * @memberof FineMetricItem
     */
    group: number;
    /**
     * 
     * @type {string}
     * @memberof FineMetricItem
     */
    activity: string;
}

/**
 * Check if a given object implements the FineMetricItem interface.
 */
export function instanceOfFineMetricItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "value" in value;
    isInstance = isInstance && "group" in value;
    isInstance = isInstance && "activity" in value;

    return isInstance;
}

export function FineMetricItemFromJSON(json: any): FineMetricItem {
    return FineMetricItemFromJSONTyped(json, false);
}

export function FineMetricItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): FineMetricItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'value': json['value'],
        'group': json['group'],
        'activity': json['activity'],
    };
}

export function FineMetricItemToJSON(value?: FineMetricItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'value': value.value,
        'group': value.group,
        'activity': value.activity,
    };
}

